<div style="padding-bottom:45px;">
  <app-bread-crumbs [activePage]="activePage"
    (buttonActionHandler)="breadcrumbsButtonActionHandler($event)">
  </app-bread-crumbs>
</div>

<div *ngIf="isLoading || !userDropdown || userDropdown.length === 0" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <app-layout class="container--form">

    <shared-alert [type]="alertType.Error" *ngIf="downloadErrorMessage">
      <p alert-content class="my-2">{{downloadErrorMessage}}</p>
    </shared-alert>

    <form [formGroup]="filtersForm">

      <div class="section--filter mt-3">
        <mat-expansion-panel expanded="true" togglePosition="before">
          <mat-expansion-panel-header>
            <mat-panel-title>Filter</mat-panel-title>
            <!-- <app-button  name="Reset" type="tertiary-button" (click)="resetFilter($event)"></app-button> -->
          </mat-expansion-panel-header>

          <div class="container pt-3">
            <div class="d-flex row">
              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> MP Document Number </p>
                <mat-form-field appearance="fill" class="custom-form-field--text"
                  [ngClass]="{'has-error': filtersForm.get('MPDocumentNumber')?.hasError(ValidationError.INVALID_MP_DOCUMENT_NUMBER)}">
                  <input matInput formControlName="MPDocumentNumber" placeholder="Filter by MP document number">
                  <button class="clear-button" *ngIf="filtersForm.get('MPDocumentNumber')?.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="filtersForm.get('MPDocumentNumber')?.setValue('')">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>

                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('MPDocumentNumber')?.hasError(ValidationError.INVALID_MP_DOCUMENT_NUMBER)">
                  Fill in a valid MP document number
                </p>
              </div>

              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> PE Name </p>
                <ng-container>
                  <ng-select class="custom-ng-select--multiple MyPurchase-multi-select" [items]="peDropdown"
                    bindLabel="value" bindValue="id" groupBy="groupBy" [multiple]="true" [closeOnSelect]="false"
                    [selectableGroup]="true" [selectableGroupAsModel]="false" appearance="outline"
                    formControlName="purchaseExecutives" [placeholder]="selectedPurchaseExecutivesLabel">
                    <ng-template ng-label-tmp let-item="item" let-index="index">
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                      <mat-checkbox [checked]="isEveryPurchaseExecutiveChecked">
                        <ng-container *ngIf="isEveryPurchaseExecutiveChecked">
                          <img src="/assets/images/select-check.svg" alt="Checked" width="20" height="20">
                        </ng-container>
                        <ng-container
                          *ngIf="!isEveryPurchaseExecutiveChecked && filtersForm.get('purchaseExecutives')!.value.length === 0">
                          <img src="/assets/images/unselect-check.svg" alt="Unchecked" width="20" height="20">
                        </ng-container>
                        <ng-container
                          *ngIf="!isEveryPurchaseExecutiveChecked && filtersForm.get('purchaseExecutives')!.value.length !== 0">
                          <img src="/assets/images/partial-check.svg" alt="Partial" width="20" height="20">
                        </ng-container>
                        Select All
                      </mat-checkbox>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <mat-checkbox [checked]="isSelected(item.id)">
                        <ng-container *ngIf="isSelected(item.id); else uncheckedSelected">
                          <img src="/assets/images/select-check.svg" alt="Checked" width="20" height="20">
                        </ng-container>
                        <ng-template #uncheckedSelected>
                          <img src="/assets/images/unselect-check.svg" alt="empty-checkbox" width="20" height="20">
                        </ng-template>
                        {{item.value}}</mat-checkbox>
                    </ng-template>
                  </ng-select>
                </ng-container>
              </div>

              <div class="form-field col-4">
                <p class="mb-1 paragraph-medium-regular"> RO Name </p>
                <ng-container>
                  <ng-select class="custom-ng-select--multiple MyPurchase-multi-select" [items]="userDropdown"
                    bindLabel="value" bindValue="id" groupBy="groupBy" [multiple]="true" [closeOnSelect]="false"
                    [selectableGroup]="true" [selectableGroupAsModel]="false" appearance="outline"
                    formControlName="requestingOfficer" dropdownPosition="bottom"
                    [placeholder]="selectedRequestingOfficerLabel">
                    <ng-template ng-label-tmp let-item="item" let-index="index">
                    </ng-template>
                    <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                      <mat-checkbox [checked]="isEveryRequestingOfficerChecked">
                        <ng-container *ngIf="isEveryRequestingOfficerChecked">
                          <img src="/assets/images/select-check.svg" alt="Checked" width="20" height="20">
                        </ng-container>
                        <ng-container
                          *ngIf="!isEveryRequestingOfficerChecked && filtersForm.get('requestingOfficer')!.value.length === 0">
                          <img src="/assets/images/unselect-check.svg" alt="Unchecked" width="20" height="20">
                        </ng-container>
                        <ng-container
                          *ngIf="!isEveryRequestingOfficerChecked && filtersForm.get('requestingOfficer')!.value.length !== 0">
                          <img src="/assets/images/partial-check.svg" alt="Partial" width="20" height="20">
                        </ng-container>
                        Select All
                      </mat-checkbox>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <mat-checkbox [checked]="isSelectedRo(item.id)">
                        <ng-container *ngIf="isSelectedRo(item.id); else uncheckedSelected">
                          <img src="/assets/images/select-check.svg" alt="Checked" width="20" height="20">
                        </ng-container>
                        <ng-template #uncheckedSelected>
                          <img src="/assets/images/unselect-check.svg" alt="empty-checkbox" width="20" height="20">
                        </ng-template>
                        {{item.value}}</mat-checkbox>
                    </ng-template>
                  </ng-select>
                </ng-container>
              </div>
            </div>
            <div class="form-field">
              <p class="mb-1 paragraph-medium-regular">MP Submission Date Range (Maximum 6 months)</p>
            </div>
            <div class="d-flex row">
              <div class="form-field pb-3 mt-1 col-4">
                <mat-form-field class="custom-form-field--date"
                  [ngClass]="{'has-error': filtersForm.get('startDate')?.hasError(ValidationError.CUSTOM_MISSING_START_END_DATE) || filtersForm.get('startDate')?.hasError(ValidationError.MAXIMUM_6_MONTHS)}">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="startDate" placeholder="dd/mm/yyyy" (focus)="picker.open()">
                    <input matEndDate formControlName="endDate" placeholder="dd/mm/yyyy" (focus)="picker.open()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('startDate')?.hasError(ValidationError.CUSTOM_MISSING_START_END_DATE)">
                  Fill in a valid start and end date
                </p>
                <p class="form-field-error paragraph-small-regular"
                  *ngIf="filtersForm.get('startDate')?.hasError(ValidationError.MAXIMUM_6_MONTHS)">
                  Start date to end date cannot be more than 6 months
                </p>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>

      <div class="section--report-columns mt-3">
        <mat-expansion-panel expanded="true" togglePosition="before">
          <mat-expansion-panel-header>
            <mat-panel-title> Report Columns</mat-panel-title>
            <!-- <app-button class="button--no-border" name="Reset" type="basic"
              (click)="resetCsvHeaders($event)"></app-button> -->
          </mat-expansion-panel-header>

          <div class="container pt-3">
            <div class="form-field">
              <p class="mb-2 paragraph-medium-regular">Columns To Display</p>
              <!-- <mat-radio-group formControlName="csvHeaderPreset" class="mt-2">
                <mat-radio-button [value]="CsvHeaderPreset.ALL">
                  All
                </mat-radio-button>
                <mat-radio-button [value]="CsvHeaderPreset.CUSTOM">
                  Custom
                </mat-radio-button>
              </mat-radio-group>-->
              <p class="form-field-error mt-3 mb-1 paragraph-small-regular"
                *ngIf="filtersForm.get('csvHeaderPreset')?.hasError(ValidationError.MINIMUM_ONE_CSV_HEADER)">
                Select at least one column to display
              </p>
            </div>
            <div class="form-field mt-4" formArrayName="csvHeaderKeys">
              <div class="grid-container">
                <mat-checkbox [checked]="isSelectAllColumnSelected()" [indeterminate]="isPartialSelection()"
                  (change)="toggleAllDisplayColumn($event)">
                  <!-- Checked State -->
                  <ng-container *ngIf="isSelectAllColumnSelected() && !isPartialSelection()">
                    <img src="/assets/images/select-check.svg" alt="Checked" width="24" height="24">
                  </ng-container>

                  <!-- Unchecked and No Items Selected -->
                  <ng-container *ngIf="!isSelectAllColumnSelected() && !isPartialSelection()">
                    <img src="/assets/images/unselect-check.svg" alt="Unchecked" width="24" height="24">
                  </ng-container>

                  <!-- Partially Checked State -->
                  <ng-container *ngIf="isPartialSelection()">
                    <img src="/assets/images/partial-check.svg" alt="Partial" width="24" height="24">
                  </ng-container>
                  <span class="paragraph-medium-regular">Select All</span>
                </mat-checkbox>
              </div>

              <div class="grid-container">
                <div *ngFor="let headerOption of INITIAL_CSV_HEADER_KEYS; let i = index" class="grid-item">
                  <mat-checkbox [formControlName]="i" class="mb-2" (change)="onIndividualCheckboxChange()">
                    <ng-container *ngIf="csvHeaderKeys.at(i).value">
                      <img src="/assets/images/select-check.svg" alt="Checked" width="24" height="24">
                    </ng-container>

                    <ng-container *ngIf="!csvHeaderKeys.at(i).value">
                      <img src="/assets/images/unselect-check.svg" alt="Unchecked" width="24" height="24">
                    </ng-container>

                    <span class="paragraph-medium-regular">{{ CSV_HEADER_MAPPING[headerOption] }}</span>
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </form>
  </app-layout>
</div>